import React, { createContext, PropsWithChildren, useContext } from 'react'

import { FileModel } from '@flowwai-frontend/shared-web/common/data-access'
import { i18nTProp } from '@flowwai-frontend/shared/common-components'

import { MapsFeaturesEnum } from '../constants'
import { MapCoordinates, MapStyleEnum } from '../types'
import { MapsServiceProvidersConfig } from '../types/MapsServiceProviderTypes'

interface CustomMapStyles {
   default?: string
   satellite?: string
}

export interface MapsUtilityContextType {
   serviceProvidersConfig: MapsServiceProvidersConfig
   showCRMWarningToastWithGivenMessage: (message: string) => void
   showCRMSuccessToast: (message: string) => void
   mapsT: i18nTProp

   customMapStyles?: CustomMapStyles
   defaultViewMode?: 'READ_ONLY' | 'EDIT'
   restrictToMapStyle?: MapStyleEnum
   selectedKMLFile?: FileModel | null
   supportedFeatures?: MapsFeaturesEnum[]
   renderKMLFileUploader?: () => React.ReactElement
}

const MapsUtilityContext = createContext<MapsUtilityContextType | null>(null)

interface MapsUtilityContextProviderProps
   extends MapsUtilityContextType,
      PropsWithChildren {}

export const MapsUtilityContextProvider = (
   props: MapsUtilityContextProviderProps
): React.ReactElement => {
   const { children, ...contextProps } = props

   return (
      <MapsUtilityContext.Provider value={contextProps}>
         {children}
      </MapsUtilityContext.Provider>
   )
}

export const useMapsUtilityContext = (): MapsUtilityContextType => {
   const mapsUtilityContext = useContext(MapsUtilityContext)

   if (!mapsUtilityContext) {
      throw new Error('Expected to be used within MapsUtilityContextProvider')
   }

   return mapsUtilityContext
}
